import SelectRoleNavigation from "../SelectRoleNavigation";
import SearchSkills from "../SearchSkills";

export default function SalesStepTwo({
  handleDecrement,
  handleIncrement,
  num,
  handleResults,
}) {
  return (
    <>
      <SearchSkills
        handleResults={handleResults}
        num={num}
        handleDecrement={handleDecrement}
        handleIncrement={handleIncrement}
      />
    </>
  );
}
